import { render, staticRenderFns } from "./PaysReport.vue?vue&type=template&id=87df8c3e"
import script from "./PaysReport.vue?vue&type=script&lang=js"
export * from "./PaysReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports